import { H1, Typography } from '@branch-messenger/willow-ui'
import styled from 'styled-components'

export const PageTitle = styled(H1)`
  font-size: 40px;
`

export const PageSubTitle = styled(Typography).attrs({
  $color: 'textMuted',
})``
